var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "default-modal",
    {
      attrs: {
        name: "update-item-modal",
        autofocus: _vm.$refs.itemsForm,
        successHandler: _vm.handleUpdate,
        title: _vm.$t("update_item"),
        width: "sm"
      },
      model: {
        value: _vm.modalOpened,
        callback: function($$v) {
          _vm.modalOpened = $$v
        },
        expression: "modalOpened"
      }
    },
    [
      _c("items-form", {
        ref: "itemsForm",
        attrs: { slot: "content", item: _vm.item },
        slot: "content"
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }